/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class LocationDaysOpenController {
        public static $inject: string[] = [
            'DealerwareLocationOpenDayModel',
            'DealerwareLocationOpenDayCollection',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$dealerwareInternationalizationData',
            '$dealerwareInternationalizationDateFormats'
        ];

        private _locationId: number;
        private _constructed: boolean;

        public quiet: boolean;
        public openDays: any;
        public availableTimes: any;
        public week: string[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        public daysOfWeek: string[];
        public labels: {};

        public get locationId() : number {
            return this._locationId;
        }

        public set locationId(id: number) {
            this._locationId = id;
            if (this.ready) { this.loadLocationOpenDays(); }
        }

        public get constructed() : boolean {
            return this._constructed;
        }

        public set constructed(value: boolean) {
            this._constructed = value;
            if (this.ready) { this.loadLocationOpenDays(); }
        }

        public get ready() : boolean {
            return this.locationId && this.constructed;
        }

        constructor(public openDayModel: any,
                    public openDayCollection: any,
                    public loading: any,
                    public notification: any,
                    public $dealerwareInternationalizationData: any,
                    public $dealerwareInternationalizationDateFormats: any)
        {
            this.getLabels('settings');
        }

        public getLabels(module: string) : void {
            var _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.setDaysOfWeek();
                    _self.setAvailableTimes();
                },
                function(error: any) {
                    return {}
                }
            );
        }

        private setDaysOfWeek(): void {
            this.daysOfWeek = this.week.map(itm => this.labels.days[itm]);
        }

        private setAvailableTimes(): void {
            this.availableTimes = this.$dealerwareInternationalizationDateFormats.getAvailablesTimesFormat()
        }

        private loadLocationOpenDays() : void {
            var _self = this;

            this.openDayCollection.index({
                promise: true,
                params: { location_id: this.locationId }
            }).then(
                function(returnValue: any) { _self.openDays = returnValue.data; },
                function(response: any) { _self.notification.apiError(response); }
            );
        }

        public isHourDisabled(index: number) : boolean {
            return !(this.openDays && this.openDays[index].data.open)
        }

        public isSaveDisabled() : boolean {
            var unchanged = this.openDays && this.openDays.reduce(
                (acc, openDay) => acc && openDay.isUnchanged(),
                true
              );

            return unchanged;
        }

        public save() : void {
            var _self = this;

            var loader = this.loading.show('Saving...');
            this.openDayCollection.batch_update({
                promise: true,
                params: { location_id: _self.locationId },
                data: { open_days: _self.openDays } }
            ).then(
                function(returnValue: any) {
                    _self.openDays = returnValue.data;
                    loader.close();
                },
                function(response: any) {
                    _self.notification.apiError(response);
                    loader.close();
                },
            );
        }

        public clearChanges() : void {
            this.loadLocationOpenDays();
        }
    }

    getDealerwareWebComponentsModule().controller('LocationDaysOpenController', LocationDaysOpenController);

    export class LocationDaysOpenDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'LocationDaysOpenController';
        public controllerAs     : string    =   'locationDaysOpenController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            constructed: '=',
            locationId: '=',
            quiet: '=?'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/location/days_open_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {};

        public link : ng.IDirectiveLinkFn = (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            ctrls: any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive("dealerwareLocationDaysOpen", () => new LocationDaysOpenDirective());
}
